import {
  Component,
  ViewChildren,
  QueryList,
  AfterViewInit,
  ElementRef,
  OnDestroy
} from '@angular/core';
import { SliderImage } from './image.interface';
import { timer, Subscription } from 'rxjs';
import { NgClass } from '@angular/common';

const IMAGES: SliderImage[] = [
  {
    title: 'Combat Engineer - 12B',
    url: '/assets/img/stem/carousel/combat_engineer_carousel.jpg',
    category: 'Engineering',
    careerLink:
      'https://www.goarmy.com/careers-and-jobs/mechanics-engineering/design-develop/12b-combat-engineer?iom=AFOD-2675107_STARS_Website',
    categoryLink:
      'https://www.goarmy.com/careers-and-jobs/browse-jobs?category=mechanics-engineering&iom=AFOD-2675107_STARS_Website'
  },
  {
    title: 'General Surgeon - 61J',
    category: 'Medical Corps',
    url: '/assets/img/stem/gen-surgeon.jpg',
    careerLink:
      'https://www.goarmy.com/careers-and-jobs/science-medicine/intensive-care/61j-general-surgeon?iom=AFOD-2675107_STARS_Website',
    categoryLink:
      'https://www.goarmy.com/careers-and-jobs/browse-jobs?category=science-medicine&iom=AFOD-2675107_STARS_Website'
  },
  {
    title: 'Medical Logistics Specialist - 68J',
    url: '/assets/img/stem/carousel/medical_logistics_specialist_carousel.jpg',
    category: 'Science',
    careerLink:
      'https://www.goarmy.com/careers-and-jobs/support-logistics/transportation-inventory/68j-medical-logistics-specialist?iom=AFOD-2675107_STARS_Website',
    categoryLink:
      'https://www.goarmy.com/careers-and-jobs/browse-jobs?category=science-medicine&iom=AFOD-2675107_STARS_Website'
  },
  {
    title: 'Medical Surgical Nurse - 66H',
    url: '/assets/img/stem/carousel/medical_surgical_nurse_carousel.jpg',
    category: 'Science',
    careerLink:
      'https://www.goarmy.com/careers-and-jobs/science-medicine/intensive-care/66h-medical-surgical-nurse?iom=AFOD-2675107_STARS_Website',
    categoryLink:
      'https://www.goarmy.com/careers-and-jobs/browse-jobs?category=science-medicine&iom=AFOD-2675107_STARS_Website'
  },
  {
    title: 'Microbiologist - 71A',
    category: 'Medical Services Corps',
    url: '/assets/img/stem/microbiologist.jpg',
    careerLink:
      'https://www.goarmy.com/careers-and-jobs/science-medicine/research/71a-microbiologist?iom=AFOD-2675107_STARS_Website',
    categoryLink:
      'https://www.goarmy.com/careers-and-jobs/browse-jobs?category=science-medicine&iom=AFOD-2675107_STARS_Website'
  },
  {
    title: 'Clinical Laboratory Scientist - 71E',
    url: '/assets/img/stem/carousel/clinical_laboratory_scientist_carousel.jpg',
    category: 'Science',
    careerLink:
      'https://www.goarmy.com/careers-and-jobs/science-medicine/research/71e-clinical-laboratory-specialist?iom=AFOD-2675107_STARS_Website',
    categoryLink:
      'https://www.goarmy.com/careers-and-jobs/browse-jobs?category=science-medicine&iom=AFOD-2675107_STARS_Website'
  }
];

@Component({
  selector: 'stars-stem-slider',
  templateUrl: './slider.html',
  styleUrls: ['./slider.scss'],
  imports: [NgClass]
})
export class SliderComponent implements AfterViewInit, OnDestroy {
  @ViewChildren('slide') slides: QueryList<ElementRef>;
  currentSlideIndex = 0;
  timeBetweenSlides = 10000; // 10 Seconds
  slideTimerSubscription: Subscription;

  public images = IMAGES;

  ngAfterViewInit(): void {
    this.startSlideAnimation();
  }

  ngOnDestroy(): void {
    if (this.slideTimerSubscription) {
      this.slideTimerSubscription.unsubscribe();
    }
  }

  startSlideAnimation(): void {
    this.slideTimerSubscription = timer(
      this.timeBetweenSlides,
      this.timeBetweenSlides
    ).subscribe(() => {
      this.currentSlideIndex++;
      if (this.currentSlideIndex >= this.slides.length) {
        this.currentSlideIndex = 0;
      }
    });
  }

  goToSlide(selectedIndex: number): void {
    if (selectedIndex === this.currentSlideIndex) {
      return;
    }

    if (this.slideTimerSubscription) {
      this.slideTimerSubscription.unsubscribe();
      this.currentSlideIndex = selectedIndex;
      this.startSlideAnimation();
    }
  }
}
